import React, { useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axios from 'axios';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import MapDashboard from '../myproporties/MapDashboard';
import FadeLoader from "react-spinners/FadeLoader";
import { BiSortAlt2 } from "react-icons/bi";
import './VerifyAlert.css';
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';

const ApprovedProperties = (props) => {
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

    const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
    const [filter, setFilter] = useState([]);
    const [search] = useState("");
    const [open, setOpen] = useState(false);
    const [rowData] = useState([]);
    const [areasmarked] = useState([]);
    const [isEdit] = useState();
    const [parkinglotObj] = useState();
    const [defaultaddress] = useState();
    const [loader] = useState(false);
    const [selectedStatus] = useState(''); // This will store the selected status
    const [sortDirection, setSortDirection] = useState('asc'); // State for sorting direction
    const [isSalespersonloggedin] = useState(true);
    const [myworklistredirect] = useState(true);
    const [verifiedBy, setVerfiedBy] = useState();

    // ✅ Sync props to state when props.parkingLotBookingDetails changes
    useEffect(() => {
        setParkingLotBookingDetails(props.parkingLotBookingDetails || []);
    }, [props.parkingLotBookingDetails]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userData = await GetUserDetailsFromToken();
                setVerfiedBy(userData?.firstName);
            } catch (error) {
                console.error("Error fetching user data:", error);
            }
        };

        fetchUserData();
    }, []);

    // ✅ Search & Filter logic
    useEffect(() => {
        let result = parkingLotBookingDetails;
        // Filter by search query
        if (search) {
            result = result.filter((item) =>
                (item.parkingLotAddress || item.createdDate)?.toLowerCase().includes(search.toLowerCase())
            );
        }
        if (selectedStatus.length > 0) {
            result = result.filter((item) => selectedStatus.includes(item.status));
        }
        setFilter(result);
    }, [search, parkingLotBookingDetails, selectedStatus]);

    const handleSort = (column) => {
        const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        setSortDirection(newSortDirection);

        const sortedData = [...filter].sort((a, b) => {
            const dateA = new Date(a[column]);
            const dateB = new Date(b[column]);
            return newSortDirection === 'asc' ? dateA - dateB : dateB - dateA;
        });

        setFilter(sortedData);
    };

    const handleConfirm = (text) => {
        if (text === 'confirm') {
            const requestOptions = {
                method: 'POST',
                headers: { "x-functions-key": hostHeader },
                body: JSON.stringify(rowData)
            };
            axios.post(`${hostPath}/api/DeleteParkingLotDetailsByEmailId`, requestOptions.body, { headers: requestOptions.headers })
                .then(response => {
                    if (response.data?.status) {
                        const newData = parkingLotBookingDetails.filter(item => item.parking_Lot_ID !== rowData.Parking_Lot_ID);
                        setParkingLotBookingDetails(newData);
                        setFilter(newData);
                        setOpen(false);
                    } else {
                        alert(response.data.responseMessage);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
        } else {
            setOpen(false);
        }
    };
    const columns = [
        {
            name: "Nickname",
            selector: (row) => row?.nickName,
            style: {
                minWidth: '200px', // Increase the minimum width of the column
            },
        },
        {           
           name: "Street Address",
            cell: (row) => (
                <div
                    style={{ cursor: 'pointer' }}  // Style to indicate it's clickable                  
                >
                    {row.parkingLotAddress}
                    
                </div>
            ),
        },
        {
            name: "Status",
            selector: (row) => row?.status,
        },

        {
            name: "Created By",
            selector: (row) => row?.createdBy || 'NA',
        },
        {
            name: "Approved By",
            selector: (row) => row?.approvedBy || 'NA',
        },
        {
            name: (
                <div onClick={() => handleSort('createdDate')} style={{ display: 'flex', alignItems: 'center' }}>
                    Created Date <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.createdDate,
        },
        {
            name: (
                <div onClick={() => handleSort("lastUpdatedDate")} style={{ display: 'flex', alignItems: 'center' }}>
                    Last Updated <BiSortAlt2 style={{ marginLeft: '5px' }} />
                </div>
            ),
            selector: (row) => row.lastUpdatedDate,
        },

        {
            name: "Comments",
            selector: (row) => row.comment || 'NA',
        },
    ];

    const tableHeaderStyle = {
        headCells: {
            style: {
                height: "90px",
                fontWeight: 800,
                fontSize: "16px",
                backgroundColor: "white",
                fontFamily: "Lato",
                textAlign: "left",
                borderBottom: "none",
            },
        },
        cells: {
            style: { minWidth: '200px' },
        },
    };
    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}


            {!isEdit ? (
                <div className='container-fluid p-0'>
                    <div className="lotmanagement" style={{ margin: "0px 0px 0px 15px" }}>
                        <React.Fragment>
                            <DataTable
                                customStyles={{
                                    headCells: tableHeaderStyle.headCells,
                                    cells: {
                                        style: {
                                            fontFamily: 'Lato',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            lineHeight: '18.6px',
                                            textAlign: 'left',
                                            height: "60px",
                                            borderBottom: "none"
                                        },
                                    },
                                }}
                                columns={columns}
                                data={filter.length ? filter : []}
                                pagination
                                fixedHeader
                                selectableRowsHighlight
                                highlightOnHover
                                persistTableHead
                                noDataComponent={
                                    <div style={{ padding: '20px 0', textAlign: 'center' }}>
                                        No records found
                                    </div>
                                }
                            />
                        </React.Fragment>
                    </div>

                    {/* Delete Dialog */}
                    <Dialog
                        classes={{ paper: 'custom-paper-class-delete' }}
                        aria-labelledby="customized-dialog-title"
                        dividers
                        open={open}
                        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        <DialogTitle
                            id="customized-dialog-title"
                            sx={{ textAlign: 'start', color: "#000", fontSize: "24px", fontWeight: "700", padding: "5px 24px" }}
                        >
                            Are you Sure You Want to Delete This Property?
                        </DialogTitle>
                        <DialogContent sx={{ border: "none", padding: "5px 22px", color: "#000" }}>
                            <Typography gutterBottom>
                                Once deleted, this action is irreversible. Please confirm.
                            </Typography>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'right' }}>
                            <Button className='custom-button-cancel' onClick={() => handleConfirm('cancel')}>Cancel</Button>
                            <Button className='custom-button-delete' onClick={() => handleConfirm('confirm')}>Delete</Button>
                        </DialogActions>
                    </Dialog>

                </div>
            ) : (
                <MapDashboard
                    isEdit={isEdit}
                    areasMarked={areasmarked}
                    defaultaddress={defaultaddress}
                    parkinglotObj={parkinglotObj}
                    isSalespersonloggedin={isSalespersonloggedin}
                    myworklistredirect={myworklistredirect}
                    verifiedBy={verifiedBy}
                    checkReviewTab={props.checkReviewTab}
                />
            )}
        </div>
    );
};

export default ApprovedProperties;
